<template>
    
    <div class="main">
        <c-panel>
            <form-agenda :paramId="$route.params.id" v-on:onSubmitModelo="onSubmitAgenda"></form-agenda>
        </c-panel>
    </div>
    
</template>
<script>

import formAgenda from "./form"

export default {
    methods:{

        onSubmitAgenda(){

            this.$router.push('/admin/calendario-agendamento');  
        }
    },
    components:{ formAgenda }
}
</script>
